import { Helmet } from "react-helmet-async";

function SEO({
  title = "WorkoutAIPlan - Get Your Personalized AI Workout Plan",
  description = "Discover how AI can design smarter, more effective workout routines for your fitness goals. Free fitness guides, workout plans, and AI insights.",
  keywords = "AI workout plan, workout generator, fitness AI, personalized training, workout planner",
  image = "https://workoutaiplan.com/og-image.jpg",
  article = null,
  noindex = false,
}) {
  const siteUrl = "https://workoutaiplan.com";
  const currentUrl = typeof window !== "undefined" ? window.location.href : siteUrl;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Robots Meta */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={article ? "article" : "website"} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:site_name" content="WorkoutAIPlan" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Article-specific tags */}
      {article && (
        <>
          <meta property="article:published_time" content={article.publishDate} />
          <meta property="article:author" content={article.author} />
          {article.tags &&
            article.tags.map((tag) => <meta key={tag} property="article:tag" content={tag} />)}
        </>
      )}

      {/* Schema.org structured data */}
      {article && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline: article.title,
            description: article.description || description,
            image: article.image || image,
            datePublished: article.publishDate,
            author: {
              "@type": "Person",
              name: article.author,
            },
            publisher: {
              "@type": "Organization",
              name: "WorkoutAIPlan",
              logo: {
                "@type": "ImageObject",
                url: `${siteUrl}/logo.png`,
              },
            },
          })}
        </script>
      )}
    </Helmet>
  );
}

export default SEO;
